<template>
  <div class="wrapper">
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'

  export default {
    name: 'list',
    components: {
      tablePage,
    },
    mounted(){
        const data = {phone:this.$route.query.phone,month:this.$route.query.month};
        this.$refs.childTable.defaultQueryData(data);
    },
    data () {
      return {
        /*table生成*/
        pageData: {
          queryUrl: URL.kcharts.tradeList, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t("txmis.common.phone"), field: 'phone'},
              { title: window.$t("txmis.common.name"), field: 'name'},
              { title: window.$t("txmis.kscore.symbol"), field: 'symbol'},
              { title: window.$t("txmis.kscore.direction"), field: 'direction',render:(data,full)=>{
                  return data == 1?"买":"卖";
              }},
              { title: window.$t("txmis.kscore.openPrice"), field: 'openPrice'},
              { title: window.$t("txmis.kscore.closePrice"), field: 'closePrice'},
              { title: window.$t("txmis.kscore.profit"), field: 'profit'},
              { title: window.$t("txmis.kscore.month"), field: 'month'},
              { title: window.$t("txmis.kscore.createTime"), field: 'createTime',render:(data)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }}
          ]
        }
      }
    }
  }
</script>
